var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D1E040",
    d: "M10.63 4.247c-3.52 0-6.383 2.864-6.383 6.383 0 3.52 2.863 6.382 6.383 6.382s6.383-2.862 6.383-6.382c0-3.52-2.863-6.383-6.383-6.383zm2.491 5.987c-.063-.403-.219-.772-.448-1.087l2.135-2.134c.758.876 1.244 1.992 1.333 3.22h-3.02zM10.63 12.42c-.988 0-1.79-.802-1.79-1.79 0-.989.802-1.79 1.79-1.79.989 0 1.79.801 1.79 1.79 0 .988-.801 1.79-1.79 1.79zm1.482-3.833c-.315-.23-.684-.385-1.085-.449V5.12c1.227.087 2.343.573 3.22 1.333l-2.135 2.134zm-1.879-.449c-.401.064-.77.22-1.085.449L7.014 6.453c.875-.76 1.991-1.246 3.219-1.333v3.018zm-1.085 4.536c.315.228.684.384 1.085.447v3.018c-1.228-.087-2.344-.573-3.22-1.332l2.135-2.133zm1.879.447c.401-.063.77-.219 1.086-.447l2.134 2.133c-.877.76-1.993 1.245-3.22 1.333v-3.02zM6.453 7.013l2.134 2.134c-.23.315-.384.684-.448 1.087H5.12c.087-1.229.573-2.345 1.333-3.22zM5.12 11.027H8.14c.064.4.218.77.448 1.086l-2.134 2.134c-.76-.877-1.246-1.993-1.333-3.22zm9.688 3.22l-2.134-2.134c.228-.316.384-.685.447-1.086h3.02c-.089 1.227-.575 2.343-1.333 3.22z",
    transform: "translate(.857 .806)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A7054",
    d: "M10.63 0C4.76 0 0 4.76 0 10.63c0 5.87 4.76 10.63 10.63 10.63 5.87 0 10.63-4.76 10.63-10.63C21.26 4.76 16.5 0 10.63 0m0 17.964c-4.045 0-7.335-3.29-7.335-7.334 0-4.045 3.29-7.335 7.335-7.335 4.044 0 7.335 3.29 7.335 7.335 0 4.044-3.29 7.334-7.335 7.334",
    transform: "translate(.857 .806)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.feb47abd7de55fa69deecb07d1ca4948.svg";
export { ForwardRef as ReactComponent };